module.exports = __webpack_public_path__ + "img/Cash.fd8990c0.jpg";